import * as BasketUpdated from "@ori-events/basket-updated";
export var dispatchBasketUpdatedEvent = function (detail, eventType) {
    if (eventType === void 0) { eventType = BasketUpdated.Name; }
    var event = new CustomEvent(eventType, {
        detail: detail,
    });
    window.dispatchEvent(event);
};
export default dispatchBasketUpdatedEvent;
